import { Exception, Guid } from '../../utilities/index.js';
export class TraceContext {
    version;
    traceId;
    parentId;
    flags;
    state;
    constructor(version, traceId, parentId, flags, state) {
        this.version = version;
        this.traceId = traceId;
        this.parentId = parentId;
        this.flags = flags;
        this.state = state;
    }
    toTraceParent() {
        return `${this.version}-${this.traceId}-${this.parentId}-${this.flags}`;
    }
    toTraceState() {
        const entries = Object.entries(this.state)
            .map(([k, v]) => `${k}=${v}`);
        const state = entries.join(',');
        return state;
    }
    toCorrelation() {
        return {
            traceId: this.traceId,
            parentId: this.parentId,
        };
    }
    static parseStringOrNew(traceContextMaybe, traceStateMaybe) {
        if (!this.isValid(traceContextMaybe)) {
            return this.new();
        }
        return this.parseString(traceContextMaybe, traceStateMaybe);
    }
    static parseString(traceContextMaybe, traceStateMaybe) {
        if (!this.isValid(traceContextMaybe)) {
            throw new Exception('invalid-trace-context');
        }
        const pieces = traceContextMaybe.split('-');
        const version = pieces[0];
        const traceId = pieces[1];
        const parentId = pieces[2];
        const flags = pieces[3];
        const state = {};
        if (traceStateMaybe) {
            const parsedData = decodeURIComponent(traceStateMaybe)
                .split(',');
            for (let i = 0; i < parsedData.length; i += 1) {
                const data = parsedData[i];
                if (data) {
                    const [key, value] = data.split('=');
                    if (key && value) {
                        state[key] = value;
                    }
                }
            }
        }
        return new TraceContext(version, traceId, parentId, flags, state);
    }
    static fromTraceContext(context) {
        const state = {};
        return new TraceContext(context.version, context.traceId, context.parentId, context.flags, state);
    }
    static fromTraceIdAndRequestId(traceId, parentId) {
        const version = '00';
        const flags = '00';
        const state = {};
        return new TraceContext(version, traceId, parentId, flags, state);
    }
    static new() {
        const version = '00';
        const traceId = Guid.next()
            .toAlphaNumericString();
        const parentId = Guid.next()
            .toAlphaNumericString()
            .substring(0, 16);
        const flags = '00';
        const state = {};
        return new TraceContext(version, traceId, parentId, flags, state);
    }
    static isValid(traceMaybe) {
        return /^[\da-f]{2}-[\da-f]{32}-[\da-f]{16}-[\da-f]{2}$/.test(traceMaybe);
    }
}
//# sourceMappingURL=trace-context.js.map